export interface IHashRouteMap {
  oldRoute: RegExp
  newRoute: string
}

export function getHashRouteMapping(): IHashRouteMap[] {
  return [
    {
      newRoute: '/connection/add',
      oldRoute: new RegExp('^#/connections/add$', 'i'),
    },
    {
      newRoute: '/connection/$1',
      oldRoute: new RegExp('^#/connections/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/feed/search',
      oldRoute: new RegExp('^#/feed/detail/search$', 'i'),
    },
    {
      newRoute: '/feed/$1',
      oldRoute: new RegExp('^#/feed/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/property/add',
      oldRoute: new RegExp('^#/property/add$', 'i'),
    },
    {
      newRoute: '/property/$1',
      oldRoute: new RegExp('^#/properties/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/assignment/add',
      oldRoute: new RegExp('^#/assignments/add$', 'i'),
    },
    {
      newRoute: '/assignment/$1',
      oldRoute: new RegExp('^#/assignments/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/brokerage/listing/new',
      oldRoute: new RegExp('^#/brokerage/listings/add$', 'i'),
    },
    {
      newRoute: '/brokerage/listing/$1',
      oldRoute: new RegExp('^#/brokerage/listings/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/brokerage/pipelines',
      oldRoute: new RegExp('^#/brokerage/pipline$', 'i'),
    },
    {
      newRoute: '/brokerage/pipeline/new',
      oldRoute: new RegExp('^#/brokerage/pipeline/add$', 'i'),
    },
    {
      newRoute: '/brokerage/pipeline/$1',
      oldRoute: new RegExp('^#/brokerage/pipeline/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/calendars/assignments',
      oldRoute: new RegExp('^#/calendars/assignments/my$', 'i'),
    },
    {
      newRoute: '/calendars/brokeragePipelines',
      oldRoute: new RegExp('^#/calendars/brokeragePipelines/my$', 'i'),
    },
    {
      newRoute: '/calendars/dueDiligence',
      oldRoute: new RegExp('^#/calendars/dueDiligence/my$', 'i'),
    },
    {
      newRoute: '/calendars/listings',
      oldRoute: new RegExp('^#/calendars/listings/my$', 'i'),
    },
    {
      newRoute: '/development/city/add',
      oldRoute: new RegExp('^#/development/cities/add$', 'i'),
    },
    {
      newRoute: '/development/city/$1/edit',
      oldRoute: new RegExp('^#/development/cities/([^/]+)/edit$', 'i'),
    },
    {
      newRoute: '/development/city/$1',
      oldRoute: new RegExp('^#/development/cities/([^/]+)$', 'i'),
    },
    {
      newRoute: '/development/client/$1/edit',
      oldRoute: new RegExp('^#/development/clients/([^/]+)/edit$', 'i'),
    },
    {
      newRoute: '/development/client/$1',
      oldRoute: new RegExp('^#/development/clients/([^/]+)$', 'i'),
    },
    {
      newRoute: '/development/client/$1/site/add',
      oldRoute: new RegExp('^#/development/clients/([^/]+)/sites/add$', 'i'),
    },
    {
      newRoute: '/development/client/$1/site/$2/edit',
      oldRoute: new RegExp(
        '^#/development/clients/([^/]+)/sites/([^/]+)/edit$',
        'i',
      ),
    },
    {
      newRoute: '/development/client/$1/site/$2',
      oldRoute: new RegExp(
        '^#/development/clients/([^/]+)/sites/([^/]+)$',
        'i',
      ),
    },
    {
      newRoute: '/development/earnestMoney',
      oldRoute: new RegExp('^#/development/reports/earnestMoney$', 'i'),
    },
    {
      newRoute: '/admin/guest/$1',
      oldRoute: new RegExp('^#/admin/guests/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/admin/teams/$1',
      oldRoute: new RegExp('^#/admin/teams/detail/([^/]+)$', 'i'),
    },
    {
      newRoute: '/admin/users/$1',
      oldRoute: new RegExp('^#/admin/users/detail/([^/]+)$', 'i'),
    },
  ]
}
